import React from 'react';
import { HeartIcon, CoinsIcon, CloverIcon } from 'lucide-react';
import { services } from '../data/services';
import { Service } from '../types/content';
const icons = {
  heart: HeartIcon,
  coins: CoinsIcon,
  clover: CloverIcon
} as const;
function ServiceRow({
  service,
  index
}: {
  service: Service;
  index: number;
}) {
  const Icon = icons[service.icon];
  return <li className="grid grid-cols-[auto_1fr] items-start gap-5 border-t border-gold/15 py-8 first:border-t-0 first:pt-0 sm:gap-8" data-id="element-106" data-mp="2lb96l4v5ifkm">
      <div className="flex h-14 w-14 items-center justify-center rounded-full border border-gold/40 bg-ink-soft" data-id="element-107" data-mp="2bbief9u2ccnp">
        <Icon className="h-6 w-6 text-gold" aria-hidden="true" data-id="element-108" data-mp="1xkwsfc9bbmll" />
      </div>
      <div data-id="element-109" data-mp="22if61fy9ypzx">
        <h3 className="font-display text-2xl uppercase tracking-[0.12em] text-gold-soft sm:text-3xl" data-id="element-110" data-mp="22i59tammzmls">
          {service.title}
        </h3>
        <p className="mt-3 max-w-2xl text-base leading-relaxed text-white/70" data-id="element-111" data-mp="1nnr2i7cfq1my">
          {service.description}
        </p>
      </div>
      <span className="sr-only" data-id="element-112" data-mp="2pn1a3mx44khx">{`Servicio ${index + 1}`}</span>
    </li>;
}
export function ServicesSection() {
  return <section className="bg-ink px-5 py-16 lg:px-8 lg:py-24" id="servicios" data-id="element-113" data-mp="2kn545i4uuizq">
      <div className="mx-auto max-w-5xl" data-id="element-114" data-mp="2yohjpsg3sil3">
        <h2 className="font-display text-3xl text-gold-soft sm:text-4xl" data-id="element-115" data-mp="2ynfwyqpq67nj">
          Solución y amor
        </h2>
        <p className="mt-4 max-w-2xl text-lg text-white/70" data-id="element-116" data-mp="2un5tpltbhvcd">
          Basta ya de sufrimiento, peleas, discusiones, maltrato, rabia o
          ofensas. Ahora hay solución.
        </p>

        <ul className="mt-12" data-id="element-117" data-mp="21z9xei7nu5g4">
          {services.map((service, index) => <ServiceRow key={service.id} service={service} index={index} data-id="element-118" data-mp="2fq56nvm2mok8" data-mpi={index} />)}
        </ul>
      </div>
    </section>;
}